// 金额展示工具：Demo 数据金额已脱敏，统一以「万」为单位展示（两位小数，避免凑整观感）
export const formatWan = (value: number): string => {
  const wan = value / 10000;
  if (wan >= 1) {
    return `${wan.toFixed(2)}万`;
  }
  return `${value.toFixed(0)}元`;
};

export const formatMoney = (value: number): string => {
  return `¥${value.toFixed(2)}`;
};

export const formatPct = (value: number | undefined | null, suffix = '%'): string => {
  if (value === undefined || value === null) {
    return '—';
  }
  return `${value}${suffix}`;
};
